// TODO(jordanyu): Update the copy of these descriptions to better explain
// what data is being synced for each category.
export const MERGE_CATEGORY_DESCRIPTIONS: Record<string, string> = {
  accounting: "Accounting data",
  ats: "Applicant tracking system (ATS) data including candidates and job postings",
  crm: "Customer relationship management (CRM) data including contacts and deals",
  filestorage: "File storage data including files and folders",
  hris: "Human resources information system (HRIS) data including employees",
  knowledgebase: "Knowledge base data including articles and documentation",
  mktg: "Marketing automation data",
  ticketing: "Ticketing data including tickets and projects",
};

export const ALL_INTEGRATIONS_CATEGORY = "all";

export const INTEGRATION_CATEGORY_LABELS: Record<string, string> = {
  accounting: "Accounting",
  ats: "ATS",
  crm: "CRM",
  filestorage: "File Storage",
  hris: "HRIS",
  knowledgebase: "Knowledge Base",
  mktg: "Marketing",
  messaging: "Messaging",
  productivity: "Productivity",
  ticketing: "Support + Engineering",
};

export const INTEGRATION_CATEGORY_ORDER = [
  "hris",
  "crm",
  "mktg",
  "ticketing",
  "filestorage",
  "knowledgebase",
  "messaging",
  "productivity",
  "ats",
  "accounting",
];

export const normalizeIntegrationCategory = (category: string) =>
  category.toLowerCase().replace(/[\s_-]/g, "");

export const getIntegrationCategoryLabel = (category: string) => {
  const normalizedCategory = normalizeIntegrationCategory(category);
  return (
    INTEGRATION_CATEGORY_LABELS[normalizedCategory] ||
    category.replace(/[_-]/g, " ")
  );
};

export const sortIntegrationCategories = (categories: readonly string[]) => {
  const uniqueCategories = Array.from(
    new Set(categories.map(normalizeIntegrationCategory)),
  );

  return uniqueCategories.sort((a, b) => {
    const aIndex = INTEGRATION_CATEGORY_ORDER.indexOf(a);
    const bIndex = INTEGRATION_CATEGORY_ORDER.indexOf(b);

    if (aIndex !== -1 || bIndex !== -1) {
      if (aIndex === -1) {
        return 1;
      }
      if (bIndex === -1) {
        return -1;
      }
      return aIndex - bIndex;
    }

    return getIntegrationCategoryLabel(a).localeCompare(
      getIntegrationCategoryLabel(b),
    );
  });
};
